import React from 'react';
import { motion } from 'framer-motion';
import { Check, Briefcase, Wrench, FileCheck, HardHat, Leaf } from 'lucide-react';
export function DesireSection() {
  const features = [{
    icon: Briefcase,
    text: 'Technisch geschoolde specialisten'
  }, {
    icon: Wrench,
    text: 'Eigen materieel en professioneel gereedschap'
  }, {
    icon: FileCheck,
    text: 'Strikte naleving van normen en regelgeving'
  }, {
    icon: HardHat,
    text: 'Veilig werken volgens VCA**'
  }, {
    icon: Leaf,
    text: 'Continue aandacht voor kwaliteit, veiligheid en milieu'
  }];
  return <section className="py-24 bg-[#F8FAFC]" data-id="element-41">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-42">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-43">
          {/* Left Column: Image */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative order-2 lg:order-1" data-id="element-44">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl h-[500px]" data-id="element-45">
              <img src="https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=800&q=80" alt="Technical team working together" className="w-full h-full object-cover" data-id="element-46" />
              <div className="absolute inset-0 bg-[#2E78B6]/20 mix-blend-multiply" data-id="element-47"></div>
            </div>

            {/* Quote Card Overlay */}
            <div className="absolute -bottom-8 -right-8 max-w-sm bg-[#2E78B6] p-8 rounded-xl shadow-xl text-white hidden md:block" data-id="element-48">
              <p className="font-medium text-lg italic leading-relaxed" data-id="element-49">
                "Wij denken altijd mee over de meest efficiënte en
                bedrijfseconomische oplossing."
              </p>
            </div>
          </motion.div>

          {/* Right Column: Content */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="order-1 lg:order-2" data-id="element-50">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-51">
              Het verlengstuk van uw technische organisatie
            </h2>
            <p className="text-xl text-gray-600 leading-relaxed mb-10" data-id="element-52">
              Onze organisatie is volledig ingericht op samenwerking met grote
              installateurs. Wij werken projectmatig, op urenbasis of via
              onderhoudscontracten.
            </p>

            <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100" data-id="element-53">
              <h3 className="text-lg font-bold text-gray-900 mb-6 border-b border-gray-100 pb-4" data-id="element-54">
                Wat u van ons mag verwachten:
              </h3>
              <ul className="space-y-6" data-id="element-55">
                {features.map((feature, index) => <motion.li key={index} initial={{
                opacity: 0,
                x: 10
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: index * 0.1
              }} className="flex items-start gap-4" data-id="element-56">
                    <div className="bg-blue-50 p-2 rounded-lg flex-shrink-0" data-id="element-57">
                      <Check className="w-5 h-5 text-[#F57C00]" data-id="element-58" />
                    </div>
                    <span className="text-gray-700 font-medium text-lg" data-id="element-59">
                      {feature.text}
                    </span>
                  </motion.li>)}
              </ul>
            </div>

            {/* Mobile-only quote */}
            <div className="mt-8 bg-[#2E78B6] p-6 rounded-xl shadow-lg text-white md:hidden" data-id="element-60">
              <p className="font-medium italic" data-id="element-61">
                "Wij denken altijd mee over de meest efficiënte en
                bedrijfseconomische oplossing."
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}